import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import ThemeProvider from './theme-provider';
// import lightTheme, {createLightTheme} from './themes/light-theme';
import { BrowserRouter } from 'react-router-dom';
//language translator
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18next/i18n';
// Import i18n messages
// import { translationMessages } from './i18n';

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      {/* <ThemeProvider theme={lightTheme}> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </ThemeProvider> */}
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
